import React from 'react';
import { PersonInformation, PersonInformationModifier } from '../../../../components/molecules/PersonInformation';
import { useSonTranslation } from '../../../../translation/useSonTranslation';
import { PostReply } from '../Post.types';
import { isDeletedUser } from '../../../../types/api/UserProfile';
import { dateFromNow } from '../../../../lib/DateFormat';
import { Icons } from '../../../../components/atoms/SVG';
import { StatusInfoIcon } from '../../StatusInfo/partials/StatusInfoIcon';
import { TooltipPlacement } from '../../../../components/atoms/Tooltip';
import { ExtendedInfo, ExtendedInfoModifier } from '../../ExtendedInfo/partials/ExtendedInfo';

type PostMetadataProps = {
  model: PostReply;
};

export function PostMetadata({ model }: PostMetadataProps) {
  const { t } = useSonTranslation('Posts');

  return (
    <div className="posts__metadata">
      <PersonInformation
        {...model.author}
        infoCardUrl={isDeletedUser(model.author) ? undefined : model.author.personInfoCardUrl}
        modifier={PersonInformationModifier.POST}
      />
      <dl className="posts__time-container">
        <dt className="invisible">{t('default.created')}:</dt>
        <dd>
          <time dateTime={model.createDate} className="posts__time font-regular-15-19">
            {dateFromNow(model.createDate)}
          </time>
          {model.editDate && (
            <time dateTime={model.editDate} className="posts__time font-regular-15-19">
              {t(`default.replied`) + dateFromNow(model.editDate)}
            </time>
          )}
        </dd>
      </dl>
      {model.flaggedInappropriate && (
        <div className="posts__flagged">
          <ExtendedInfo
            helpText={t('default.flaggedInappropriate')}
            tooltipPlacement={TooltipPlacement.TOP}
            modifier={ExtendedInfoModifier.RED}
          >
            <StatusInfoIcon icon={Icons.FEEDBACK_ERROR} />
          </ExtendedInfo>
        </div>
      )}
    </div>
  );
}
